import { z } from "zod";

/** A non-negative USDT-style decimal string (up to 8 dp), e.g. "0", "100", "250.5".
 *  Rejects "", "NaN", "-1", and other non-numeric text at the API boundary. */
export const NonNegativeDecimalStringSchema = z.string().regex(/^(?:0|[1-9]\d*)(?:\.\d{1,8})?$/, {
  error: "must be a non-negative decimal with up to 8 decimals",
});

/** A signed decimal string, e.g. "-12.5", "0", "3". Money on the wire without a `Decimal` instance. */
export const SignedDecimalStringSchema = z.string().regex(/^-?(?:0|[1-9]\d*)(?:\.\d+)?$/, {
  error: "must be a decimal string",
});

/** A strictly positive decimal string, any precision, e.g. "0.0000123", "65000". */
export const PositiveDecimalStringSchema = z
  .string()
  .regex(/^(?:[1-9]\d*(?:\.\d+)?|0\.\d*[1-9]\d*)$/, { error: "must be a positive decimal string" });

/** A {@link PositiveDecimalStringSchema} with at most 12 integer digits, so it fits a DECIMAL(20,8) column. */
export const PositiveDecimal20x8StringSchema = PositiveDecimalStringSchema.regex(/^(?:0|[1-9]\d{0,11})(?:\.|$)/, {
  error: "must have at most 12 digits before the decimal point",
});
